import React, { useState } from 'react';
import Modal from 'react-modal';
import Input from '../TravellerContactInfo/FormFields/Input';
import { customStyles, UserFlowModalState } from '../UserFlow/UserFlowModal';
import './LoginModals.css';
import { If } from 'react-extras';

const initialStates = {
  showModal: true,
  validationFail: true,
};

const GetPasswordSuccess = (props: UserFlowModalState) => {
  const [ state, setState ] = useState(initialStates);
  const closeModal = () => {
    setState({
      ...state,
      showModal: false,
    });
    props.closeModal();
  };

  const userNameVerified = () => {
    props.updateVerifiedUser(props.userStatus.userId);
  };

  const goToIRCTCRegistrationPage = () => {
    props.createAccount();
  };

  const { userStatus: { userId, mobileEntered }, allowClose } = props;
  const { showModal, validationFail } = state;

  return (
    <Modal
      isOpen={showModal}
      ariaHideApp={false}
      onRequestClose={closeModal}
      className="loginModals loginModals--v3 resetPass"
      id="mmt-irctc-reset-pass"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          backgroundColor: 'rgb(0, 0, 0, 0.6)',
          zIndex: 1,
        },
        customStyles,
      }}
    >
      <div className="leftPanel">
        <p className="modalTitle font26 latoBloack blackText">
          Username Verified!
        </p>
        <p className="font20 latoBold darkGreyText appendBottom10">
          Do you remember your password?
        </p>
        <p className="font14 darkGreyText appendBottom30">
          Password is required by IRCTC for authentication after payment and
          <span className="redText">your booking might fail</span>
          if you don’t remember it.
        </p>
        <div className="makeFlex appendBottom50 end">
          <div className={`makeFlex column appendRight2 spaceBetween ${validationFail ? 'hrtlCenter' : 'end'}`}>
            <Input
              labelName="IRCTC USERNAME"
              errorMessage="Please enter OTP."
              validationFail={false}
              type="text"
              additionalAttributes={{ placeholder: userId }}
              fieldId="IRCTCUserName"
              fieldName="IRCTCUserName"
              vaidationMsg="Verified"
              vaidationMoreMsg="Change"
              vaidationMoreStatus={false}
              vaidationStatus
              readOnly={false}
            />
          </div>
        </div>
        <p>
          <a className="font16 latoBold" onClick={userNameVerified}>Continue Booking</a>
        </p>
      </div>
      <div className="rightPanel">
        <p className="textRight makeFlex spaceBetween start modalCloseCont accountSuccess">
          <span className="font26 latoBlack accountCreatedRound appendRight5 textCenter"><span
            className="checkmark"/></span>
          <If condition={allowClose === true}>
            <span
              className="modalClose"
              onClick={closeModal}
            >
            X
            </span>
          </If>
        </p>

        <p className="font20 latoBold darkGreyText appendBottom10">Password Reset</p>
        <p className="font14 appendBottom40">You will get an SMS on <b>{mobileEntered}</b> from IRCTC with a new
          password within 4-5 mins.</p>

        <div className="appendBottom30 end">

          <p className="font14 darkGreyText paddingT30 appendBottom5">Didn’t receive password?</p>
          <p className="appendBottom20 opactityD6"><a className="font16 latoBold ">Resend Email OTP in 00:29</a></p>

          <p className="font14 darkGreyText paddingT20 appendBottom5">Facing trouble?</p>
          <p className="appendBottom40"><a className="font16 latoBold " onClick={goToIRCTCRegistrationPage}>Create New
            Account</a></p>

        </div>
      </div>
    </Modal>
  );
}
export default GetPasswordSuccess;
